// Import model
import { Discount } from '../models/Discount';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DiscountRate } from '../models/DiscountRate';

// Import dependency serializers (for complex types)
import { DiscountRateSerializer } from './DiscountRateSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Discount - handles JSON serialization and deserialization with type validation
 */
export class DiscountSerializer {
  /**
   * Deserializes a JSON string into a Discount instance
   */
  static deserialize(json: string): Discount {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Discount instance
   */
  static fromObject(obj: any): Discount {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Discount');
    }


    const instance: Discount = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      discountsRates: obj['discountsRates'] ? (obj['discountsRates'] as any[]).map((item: any) =>
        DiscountRateSerializer.fromObject(item)
      ) : [] as any,
      priceDiscount: obj['priceDiscount'] as number | undefined,
      taxDiscount: obj['taxDiscount'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Discount instances
   */
  static deserializeArray(json: string): Discount[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Discount instance to a JSON string
   */
  static serialize(instance: Discount): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Discount instance to a plain object
   */
  static toObject(instance: Discount): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'isActive': instance.isActive,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      'discountsRates': instance.discountsRates?.map((item: any) =>
        DiscountRateSerializer.toObject(item)
      ),
      'priceDiscount': instance.priceDiscount,
      'taxDiscount': instance.taxDiscount,
    };
  }

  /**
   * Serializes an array of Discount instances to a JSON string
   */
  static serializeArray(instances: Discount[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
